import { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Prevent scrolling behind the menu when mobile view is active
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className="intro-page">
      {/* HEADER & NAVIGATION */}
      <header className="navbar-container">
        <nav className="navbar">
          <div className="logo">
            <img src="/images/logo.png" alt="AS Arabian Story Logo" />
          </div>

          <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
            <a href="#home" onClick={closeMenu}>Home</a>
            <a href="#about" onClick={closeMenu}>About</a>
            <a href="#collection" onClick={closeMenu}>Collection</a>
            <a href="#contact" onClick={closeMenu}>Contact</a>
            <button className="shop-btn mobile-only" onClick={closeMenu}>Shop Now</button>
          </div>

          <button className="shop-btn desktop-only">Shop Now</button>

          {/* Minimalist Hamburger Button */}
          <button 
            className={`hamburger ${isMenuOpen ? "open" : ""}`} 
            onClick={() => setIsMenuOpen(!isMenuOpen)} 
            aria-label="Toggle Navigation menu"
          >
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </nav>
      </header>

      {/* HERO SECTION */}
      <main className="hero" id="home">
        <div className="hero-content">
          <p className="small-title tracking-widest">
            LUXURY • ELEGANCE • ARABIAN HERITAGE
          </p>

          <h1>
            Discover Your
            <span className="brand-accent"> Arabian Story</span>
          </h1>

          <p className="description">
            Experience the timeless elegance of Arabian fragrance.
            A luxurious scent crafted to tell your unique story.
          </p>

          <div className="buttons-group">
            <button className="btn btn-primary">
              Explore Collection
            </button>
            <button className="btn btn-secondary">
              Discover More <span className="arrow">→</span>
            </button>
          </div>
        </div>

        <div className="hero-image-wrapper">
          <img
            src="/images/arabian-story.png"
            alt="AS Arabian Story Perfume bottle presentation"
            className="hero-img"
          />
        </div>
      </main>

      {/* ABOUT SECTION */}
      <section className="about-section" id="about">
        <div className="section-container">
          <div className="about-image-wrapper">
            <img
              src="/images/about.png"
              alt="Artistic visual representing Arabian Story Perfume ingredients"
              className="about-img"
            />
          </div>
        </div>
      </section>

      {/* FEATURES / BRAND PILLARS */}
      <section className="features-section">
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-num">01</span>
            <h3>Luxury Fragrance</h3>
            <p className="feature-desc">Curated rare oils and premium notes blended by world-class master perfumers.</p>
          </div>

          <div className="feature-card">
            <span className="feature-num">02</span>
            <h3>Arabian Heritage</h3>
            <p className="feature-desc">Deeply rooted rich traditions balancing traditional oud, musk, and clean modern finishes.</p>
          </div>

          <div className="feature-card">
            <span className="feature-num">03</span>
            <h3>Timeless Elegance</h3>
            <p className="feature-desc">An unforgettable trail designed to turn heads and resonate beautifully through generations.</p>
          </div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="contact-section" id="contact">
        <div className="contact-container">
          <div className="contact-header">
            <p className="small-title text-center">GET IN TOUCH</p>
            <h2>Begin Your <span className="brand-accent">Arabian Story</span></h2>
            <p className="contact-subtitle">
              Have a question about our collections or bespoke fragrances? We would love to guide you. Send us a message and our concierge team will assist you.
            </p>
          </div>
          
          <div className="contact-grid">
            <div className="contact-info-block">
              <h4>Email</h4>
              <p><a href="mailto:info@tadeem.co.uk" className="text-link">info@tadeem.co.uk</a></p>
            </div>

            <div className="contact-info-block">
              <h4>Phone</h4>
              <p><a href="tel:+447448887876" className="text-link">+44 7448 887876</a></p>
            </div>

            <div className="contact-info-block address">
              <h4>Location</h4>
              <h5>United Kingdom Head Office</h5>
              <address>
                Breightmet Fold House, Office Number. 7<br />
                ARed Bridge Works, BL25PH<br />
                Bolton
              
              </address>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-content">
          <p>© 2026 AS Arabian Story. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;